import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { tableCustomStyles } from "../../../utils/TableCustomStyles";
import PlaceholderPicture from "../../../images/placeholder-profile.png";

function RoleMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [roleData, setRoleData] = useState([]);
  const [roleDataPending, setRoleDataPending] = useState(true);
  const [allRolePermissionData, setAllRolePermissionData] = useState([]);
  const [rolePermissionData, setRolePermissionData] = useState([]);
  const [showRolePermissionModel, setShowRolePermissionModel] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedRolePermissionData, setSelectedRolePermissionData] = useState(
    [],
  );
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [recordForUpdate, setRecordForUpdate] = useState(null);
  const [recordForDelete, setRecordForDelete] = useState(null);

  // ---------- Add form state ----------
  const [addUserType, setAddUserType] = useState("client");
  const [addRole, setAddRole] = useState("");
  const [addRoleName, setAddRoleName] = useState("");
  const [addRoleIcon, setAddRoleIcon] = useState(null); // File object
  const [addStatus, setAddStatus] = useState("ACTIVE");

  // Add field errors
  const [showUserTypeError, setShowUserTypeError] = useState(false);
  const [showRoleError, setShowRoleError] = useState(false);
  const [showRoleNameError, setShowRoleNameError] = useState(false);
  const [showIconError, setShowIconError] = useState(false);
  const [showStatusError, setShowStatusError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state ----------
  const [updateUserType, setUpdateUserType] = useState("");
  const [updateRole, setUpdateRole] = useState("");
  const [updateRoleName, setUpdateRoleName] = useState("");
  const [updateRoleIcon, setUpdateRoleIcon] = useState(null); // File object or existing URL string
  const [updatePermission, setUpdatePermission] = useState([]);
  const [updateNotification, setUpdateNotification] = useState([]);
  const [updateStatus, setUpdateStatus] = useState("");

  // Update field errors
  const [showUpdateUserTypeError, setShowUpdateUserTypeError] = useState(false);
  const [showUpdateRoleError, setShowUpdateRoleError] = useState(false);
  const [showUpdateRoleNameError, setShowUpdateRoleNameError] = useState(false);
  const [showUpdateIconError, setShowUpdateIconError] = useState(false);
  const [showUpdateStatusError, setShowUpdateStatusError] = useState(false);
  const user_role = sessionStorage["userrole"];
  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // Filter States
  const [permissionFilters, setPermissionFilters] = useState({
    module: "",
    submodule: "",
    permission: "",
  });

  const handlePermissionFilterChange = (key, value) => {
    setPermissionFilters((prev) => ({ ...prev, [key]: value }));
  };

  const clearPermissionFilters = () => {
    setPermissionFilters({ module: "", submodule: "", permission: "" });
  };

  const filteredPermissionData = allRolePermissionData.filter(
    (item) =>
      item.module
        ?.toLowerCase()
        .includes(permissionFilters.module.toLowerCase()) &&
      item.submodule
        ?.toLowerCase()
        .includes(permissionFilters.submodule.toLowerCase()) &&
      item.permission
        ?.toLowerCase()
        .includes(permissionFilters.permission.toLowerCase()),
  );

  // ========== Helper: Title Case ==========
  const toTitleCase = (str) => {
    str = str.toLowerCase();
    str = str.split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(" ");
  };

  // ========== Real‑time error helpers for Add ==========
  const hasAnyAddError = () => {
    return (
      showUserTypeError ||
      showRoleError ||
      showRoleNameError ||
      showIconError ||
      showStatusError
    );
  };

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addUserType) errors.push("User Type is required");
    if (!addRole) errors.push("Role is required");
    if (!addRoleName) errors.push("Role Name is required");
    if (!addRoleIcon) errors.push("Role Icon is required");
    if (!addStatus) errors.push("Status is required");
    return errors;
  };

  // ========== Real‑time error helpers for Update ==========
  const hasAnyUpdateError = () => {
    return (
      showUpdateUserTypeError ||
      showUpdateRoleError ||
      showUpdateRoleNameError ||
      showUpdateIconError ||
      showUpdateStatusError
    );
  };

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateUserType) errors.push("User Type is required");
    if (!updateRole) errors.push("Role is required");
    if (!updateRoleName) errors.push("Role Name is required");
    if (!updateStatus) errors.push("Status is required");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);

  // ========== API calls ==========
  const getRole = async () => {
    try {
      setRoleDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/role/",
      );
      setRoleData(response.data);
    } catch (err) {
      toast.error("Error in fetching role data! Try again.");
    } finally {
      setRoleDataPending(false);
    }
  };

  const getRolePermission = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/rolepermissions/",
      );
      setAllRolePermissionData(response.data);
    } catch (err) {
      toast.error("Error in fetching permission data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getRole();
    getRolePermission();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleSetDeleteData = (row) => {
    setRecordForDelete(row);
    setShowDeleteModal(true);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/role/" + id + "/",
      );
      setShowDeleteModal(false);
      getRole();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic ==========
  const resetAddForm = () => {
    setAddUserType("client");
    setAddRole("");
    setAddRoleName("");
    setAddRoleIcon(null);
    setAddStatus("ACTIVE");
    setShowUserTypeError(false);
    setShowRoleError(false);
    setShowRoleNameError(false);
    setShowIconError(false);
    setShowStatusError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewRecord = async (e) => {
    e.preventDefault();

    setShowUserTypeError(!addUserType);
    setShowRoleError(!addRole);
    setShowRoleNameError(!addRoleName);
    setShowIconError(!addRoleIcon);
    setShowStatusError(!addStatus);
    setValidationErrorArray(buildAddErrorMessages());

    if (
      !addUserType ||
      !addRole ||
      !addRoleName ||
      !addRoleIcon ||
      !addStatus
    ) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const formData = new FormData();
    formData.append("user_type", addUserType);
    formData.append("role", addRole.toLowerCase());
    formData.append("role_name", toTitleCase(addRoleName));
    formData.append("role_icon", addRoleIcon);
    formData.append("permissions", JSON.stringify([]));
    formData.append("notifications", JSON.stringify([]));
    formData.append("status", addStatus);

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/role/",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Role Created Successfully");
        handleAddModalClose();
        getRole();
      }
    } catch (err) {
      toast.error("Error creating role");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic ==========
  const resetUpdateForm = () => {
    setUpdateUserType("");
    setUpdateRole("");
    setUpdateRoleName("");
    setUpdateRoleIcon(null);
    setUpdatePermission([]);
    setUpdateNotification([]);
    setUpdateStatus("");
    setShowUpdateUserTypeError(false);
    setShowUpdateRoleError(false);
    setShowUpdateRoleNameError(false);
    setShowUpdateIconError(false);
    setShowUpdateStatusError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
  };

  const handleSetUpdateData = (row) => {
    setRecordForUpdate(row);
    setUpdateUserType(row.user_type);
    setUpdateRole(row.role);
    setUpdateRoleName(row.role_name);
    setUpdateRoleIcon(row.role_icon); // This is the URL string
    setUpdatePermission(row.permissions);
    setUpdateNotification(row.notifications);
    setUpdateStatus(row.status);
    // Reset errors
    setShowUpdateUserTypeError(false);
    setShowUpdateRoleError(false);
    setShowUpdateRoleNameError(false);
    setShowUpdateIconError(false);
    setShowUpdateStatusError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
  };

  const updateRecord = async (e) => {
    e.preventDefault();

    setShowUpdateUserTypeError(!updateUserType);
    setShowUpdateRoleError(!updateRole);
    setShowUpdateRoleNameError(!updateRoleName);
    setShowUpdateStatusError(!updateStatus);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (!updateUserType || !updateRole || !updateRoleName || !updateStatus) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const formData = new FormData();
    formData.append("user_type", updateUserType);
    formData.append("role", updateRole.toLowerCase());
    formData.append("role_name", toTitleCase(updateRoleName));
    if (updateRoleIcon && typeof updateRoleIcon !== "string") {
      formData.append("role_icon", updateRoleIcon);
    }

    // Append each permission ID individually
    if (updatePermission && updatePermission.length > 0) {
      updatePermission.forEach((permId) =>
        formData.append("permissions", permId),
      );
    }
    // Append each notification ID individually
    if (updateNotification && updateNotification.length > 0) {
      updateNotification.forEach((notifId) =>
        formData.append("notifications", notifId),
      );
    }

    formData.append("status", updateStatus);

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/" +
          recordForUpdate.id +
          "/",
        formData,
        { headers: { "content-type": "multipart/form-data" } },
      );
      if (response.status === 200) {
        toast.success("Role Updated Successfully");
        handleUpdateModalClose();
        getRole();
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating role");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Permission Modal logic ==========
  const showPermissions = async (id) => {
    const response = await axios.get(
      process.env.REACT_APP_BACKEND_API_URL + "/user/role/" + id,
    );
    setRolePermissionData(response.data);
    setSelectedRolePermissionData(response?.data?.permissions);
    setShowRolePermissionModel(true);
  };

  const handlePermissionChange = (id) => {
    setSelectedRolePermissionData((prevPermissions) =>
      prevPermissions?.includes(id)
        ? prevPermissions?.filter((permId) => permId !== id)
        : [...prevPermissions, id],
    );
  };

  const updateRolePermission = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const data = {
      id: rolePermissionData?.id,
      role: rolePermissionData?.role,
      permissions: selectedRolePermissionData,
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/updaterolepermission/",
        data,
        { headers: { "Content-Type": "application/json" } },
      );
      if (response) {
        toast.success("Role Permissions Updated Successfully");
        setShowRolePermissionModel(false);
        getRole();
      }
    } catch (err) {
      toast.error("Error updating permissions");
    } finally {
      setIsSubmitting(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    {
      name: "Icon",
      width: "100px",
      selector: (row) => (
        <>
          {row.role_icon != null ? (
            <img
              src={row.role_icon}
              className="img img-thumbnail"
              style={{ height: 30, width: 30 }}
              alt="icon"
            />
          ) : (
            <img
              src={PlaceholderPicture}
              className="img img-thumbnail border"
              height={30}
              width={30}
              alt="placeholder"
            />
          )}
        </>
      ),
    },
    { name: "Role", selector: (row) => row.role, sortable: true },
    { name: "Role Name", selector: (row) => row.role_name, sortable: true },
    { name: "User Type", selector: (row) => row.user_type, sortable: true },
    {
      name: "Permissions",
      center: true,
      selector: (row) => (
        <Button
          className="btn btn-sm btn-inox-green border-0 px-4"
          onClick={() => showPermissions(row.id)}
        >
          View Permissions
        </Button>
      ),
    },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:role:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:role:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleSetDeleteData(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
      width: "110px",
    },
  ];

  const rolepermissioncolumns = [
    {
      name: (
        <div className="form-group">
          <label>Module</label>
          <input
            className="form-control form-control-sm my-1"
            value={permissionFilters.module}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) =>
              handlePermissionFilterChange("module", e.target.value)
            }
            style={{ width: "120px" }}
          />
        </div>
      ),
      selector: (row) => row.module,
      width: "25%",
      sortable: true,
    },
    {
      name: (
        <div className="form-group">
          <label>Submodule</label>
          <input
            className="form-control form-control-sm my-1"
            value={permissionFilters.submodule}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) =>
              handlePermissionFilterChange("submodule", e.target.value)
            }
            style={{ width: "120px" }}
          />
        </div>
      ),
      selector: (row) => row.submodule,
      width: "25%",
      sortable: true,
    },
    {
      name: (
        <div className="form-group">
          <label>Permission</label>
          <input
            className="form-control form-control-sm my-1"
            value={permissionFilters.permission}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) =>
              handlePermissionFilterChange("permission", e.target.value)
            }
            style={{ width: "120px" }}
          />
        </div>
      ),
      selector: (row) => row.permission,
      width: "25%",
      sortable: true,
    },
    {
      name: "Assign / Revoke",
      center: true,
      selector: (row) => (
        <input
          type="checkbox"
          title="Assign / Revoke Permission"
          name={row.id}
          checked={selectedRolePermissionData?.includes(row.id)}
          onChange={() => handlePermissionChange(row.id)}
        />
      ),
      width: "25%",
    },
  ];
  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="RoleMaster"
        subMenuPermission="master:role:view"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Role Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:role:add") ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Role</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={roleData}
            progressPending={roleDataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Permission Modal */}
      <Modal
        size="lg"
        show={showRolePermissionModel}
        onHide={() => {
          setShowRolePermissionModel(false);
          clearPermissionFilters();
        }}
      >
        <form onSubmit={updateRolePermission}>
          <Modal.Header closeButton>
            <Modal.Title>
              {rolePermissionData.role_name} Role Permissions
            </Modal.Title>
            {(permissionFilters.module ||
              permissionFilters.submodule ||
              permissionFilters.permission) && (
              <Button
                className="btn btn-sm btn-secondary border-0 px-2"
                style={{ marginLeft: "16px" }}
                onClick={clearPermissionFilters}
              >
                Clear Filters
              </Button>
            )}
          </Modal.Header>
          <Modal.Body>
            <DataTable
              columns={rolepermissioncolumns}
              data={filteredPermissionData}
              progressPending={roleDataPending}
              progressComponent={
                <Spinner
                  className="mx-5 text-inox-green table-spinner"
                  as="span"
                  animation="border"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                />
              }
              noDataComponent={
                <p className="text-center table-no-data">No Data Found</p>
              }
              pagination
              highlightOnHover
              fixedHeader
              customStyles={tableCustomStyles}
              dense
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowRolePermissionModel(false)}
            >
              Close
            </Button>
            <Button
              className="btn-inox-green border-0"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <Spinner
                  className="mx-5 text-white"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Update Permissions"
              )}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* Delete Modal */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Role
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="offcanvas-body">
          <form onSubmit={addNewRecord}>
            <div className="row justify-content-center">
              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="add_user_type">
                      User Type:
                      <span className="text-danger">
                        {showUserTypeError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select"
                      id="add_user_type"
                      value={addUserType}
                      onChange={(e) => {
                        setAddUserType(e.target.value);
                        setShowUserTypeError(false);
                        setShowValidationError(false);
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowUserTypeError(e.target.value === "");
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                    >
                      <option value="client">Client</option>
                      <option value="staff">Staff</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="add_role">
                      Role:
                      <span className="text-danger">
                        {showRoleError ? " Required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="add_role"
                      placeholder="Enter Role"
                      value={addRole}
                      onChange={(e) => {
                        setAddRole(e.target.value);
                        setShowRoleError(false);
                        setShowValidationError(false);
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowRoleError(e.target.value === "");
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="add_role_name">
                      Role Name:
                      <span className="text-danger">
                        {showRoleNameError ? " Required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="add_role_name"
                      placeholder="Enter Role Name"
                      value={addRoleName}
                      onChange={(e) => {
                        setAddRoleName(e.target.value);
                        setShowRoleNameError(false);
                        setShowValidationError(false);
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowRoleNameError(e.target.value === "");
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="add_icon">
                      Role Icon:
                      <span className="text-danger">
                        {showIconError ? " Required" : ""}
                      </span>
                    </label>
                    <input
                      type="file"
                      accept="image/jpg, image/jpeg, image/png"
                      className="form-control"
                      id="add_icon"
                      onChange={(e) => {
                        setAddRoleIcon(e.target.files[0]);
                        setShowIconError(false);
                        setShowValidationError(false);
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="add_status">
                      Status:
                      <span className="text-danger">
                        {showStatusError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select"
                      id="add_status"
                      value={addStatus}
                      onChange={(e) => {
                        setAddStatus(e.target.value);
                        setShowStatusError(false);
                        setShowValidationError(false);
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowStatusError(e.target.value === "");
                        setValidationErrorArray(buildAddErrorMessages());
                      }}
                    >
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button + Error Tooltip */}
            <div className="text-center mt-4">
              <div className="canvas-btn-row">
                <Button
                  type="submit"
                  className="btn btn-inox-green border-0 canvas-button"
                  disabled={hasAnyAddError() || showAddLoader}
                >
                  {showAddLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="fa fa-plus"></i>{" "}
                      <span className="mx-2">Add</span>
                    </>
                  )}
                </Button>

                {(hasAnyAddError() || showValidationError) && (
                  <div className="error-tooltip-wrapper">
                    <Button
                      style={{ backgroundColor: "#C21E22", border: "#f82e2e" }}
                      title="Show Errors"
                      className="mx-2"
                      onClick={handleCheckValidationClick}
                      onMouseLeave={() => setIsValidationErrorVisible(false)}
                    >
                      <i className="fa fa-exclamation"></i>
                    </Button>
                    {isValidationErrorVisible && (
                      <div className="validation-error-tooltip">
                        <ul className="mb-0 px-4">
                          {validationErrorArray.map((error, index) => (
                            <li key={index} className="text-left small pb-0">
                              {error}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Role
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="offcanvas-body">
          <form onSubmit={updateRecord} encType="multipart/form-data">
            <div className="row justify-content-center">
              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label
                      className="required-label"
                      htmlFor="update_user_type"
                    >
                      User Type:
                      <span className="text-danger">
                        {showUpdateUserTypeError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select"
                      id="update_user_type"
                      value={updateUserType}
                      onChange={(e) => {
                        setUpdateUserType(e.target.value);
                        setShowUpdateUserTypeError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateUserTypeError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    >
                      <option value="client">Client</option>
                      <option value="staff">Staff</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="update_role">
                      Role:
                      <span className="text-danger">
                        {showUpdateRoleError ? " Required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="update_role"
                      placeholder="Enter Role"
                      value={updateRole}
                      onChange={(e) => {
                        setUpdateRole(e.target.value);
                        setShowUpdateRoleError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateRoleError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label
                      className="required-label"
                      htmlFor="update_role_name"
                    >
                      Role Name:
                      <span className="text-danger">
                        {showUpdateRoleNameError ? " Required" : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="update_role_name"
                      placeholder="Enter Role Name"
                      value={updateRoleName}
                      onChange={(e) => {
                        setUpdateRoleName(e.target.value);
                        setShowUpdateRoleNameError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateRoleNameError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="update_icon">
                      Role Icon: <span className="text-muted">(optional)</span>
                    </label>
                    <input
                      type="file"
                      accept="image/jpg, image/jpeg, image/png"
                      className="form-control"
                      id="update_icon"
                      onChange={(e) => setUpdateRoleIcon(e.target.files[0])}
                    />
                    {updateRoleIcon && typeof updateRoleIcon === "string" && (
                      <small>
                        Current icon: {updateRoleIcon.split("/").pop()}
                      </small>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-2">
                <div className="p-2 mt-2 quote-input-column">
                  <div className="mb-3 text-left">
                    <label className="required-label" htmlFor="update_status">
                      Status:
                      <span className="text-danger">
                        {showUpdateStatusError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select"
                      id="update_status"
                      value={updateStatus}
                      onChange={(e) => {
                        setUpdateStatus(e.target.value);
                        setShowUpdateStatusError(false);
                        setShowUpdateValidationError(false);
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                      onBlur={(e) => {
                        setShowUpdateStatusError(e.target.value === "");
                        setUpdateValidationErrorArray(
                          buildUpdateErrorMessages(),
                        );
                      }}
                    >
                      <option value="ACTIVE">ACTIVE</option>
                      <option value="INACTIVE">INACTIVE</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            {/* Submit Button + Error Tooltip */}
            <div className="text-center mt-4">
              <div className="canvas-btn-row">
                <Button
                  type="submit"
                  className="btn btn-inox-green border-0 canvas-button"
                  disabled={hasAnyUpdateError() || showUpdateLoader}
                >
                  {showUpdateLoader ? (
                    <Spinner
                      className="mx-4"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <>
                      <i className="fa fa-edit"></i>{" "}
                      <span className="mx-2">Update</span>
                    </>
                  )}
                </Button>

                {(hasAnyUpdateError() || showUpdateValidationError) && (
                  <div className="error-tooltip-wrapper">
                    <Button
                      style={{ backgroundColor: "#C21E22", border: "#f82e2e" }}
                      title="Show Errors"
                      className="mx-2"
                      onClick={handleUpdateCheckValidationClick}
                      onMouseLeave={() =>
                        setIsUpdateValidationErrorVisible(false)
                      }
                    >
                      <i className="fa fa-exclamation"></i>
                    </Button>
                    {isUpdateValidationErrorVisible && (
                      <div className="validation-error-tooltip">
                        <ul className="mb-0 px-4">
                          {updateValidationErrorArray.map((error, index) => (
                            <li key={index} className="text-left small pb-0">
                              {error}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RoleMaster;
